<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const content = field<string>("content", "");
const showPageNumber = field<boolean>("showPageNumber", true);
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:panel-bottom" accent="reporting">
    <EditorField :label="t('fields.content.label')" :hint="t('fields.content.hint')">
      <Textarea
        v-model="content"
        class="min-h-20 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.content.placeholder')"
      />
    </EditorField>

    <EditorField :label="t('fields.showPageNumber.label')">
      <div class="flex items-center justify-between gap-3">
        <span class="text-[12.5px] text-muted-foreground">{{ t("fields.showPageNumber.hint") }}</span>
        <Switch v-model="showPageNumber" />
      </div>
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Footer"
  fields:
    content:
      label: "Content"
      hint: "Supports mustache bindings resolved by the PDF compiler."
      placeholder: "Confidential"
    showPageNumber:
      label: "Page Number"
      hint: "Show page number in the footer."
</i18n>
